import Gikam from 'gikam';

export class PageConfig {

    constructor(type, comp) {
        import(`./${type}/pageConfig${Gikam.toInitialUpperCase(type)}`).then(config => {
            new config.default(comp);
        });
    }
}